import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, GmailIntegrationGenerateAuthUrlResponseDataSchema } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof GmailIntegrationGenerateAuthUrlResponseDataSchema>>

const queryKey = ["generateGmailAuthLinkQuery"]

export const generateGmailAuthLinkQuery = () => {
  return queryOptions({
    queryKey,
    queryFn: async () => {
      const response = await axios.get<Response>(`/integrations/gmail/auth`)

      return response.data.data
    },
  })
}
